import React from 'react';

export default () => (
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.875 11.375C0.875 11.859 1.26602 12.25 1.75 12.25H12.25C12.734 12.25 13.125 11.859 13.125 11.375V3.5H0.875V11.375ZM5.25 5.57813C5.25 5.39766 5.39766 5.25 5.57813 5.25H8.42188C8.60234 5.25 8.75 5.39766 8.75 5.57813V5.79688C8.75 5.97734 8.60234 6.125 8.42188 6.125H5.57813C5.39766 6.125 5.25 5.97734 5.25 5.79688V5.57813ZM13.125 0H0.875C0.391016 0 0 0.391016 0 0.875V2.1875C0 2.42813 0.196875 2.625 0.4375 2.625H13.5625C13.8031 2.625 14 2.42813 14 2.1875V0.875C14 0.391016 13.609 0 13.125 0Z" fill="currentColor" />
  </svg>
);
